import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateCustomGradients = (gradients) =>
  setSiteMeta(['customization', 'customGradients'], gradients);

export default updateCustomGradients;
